import React, { useEffect, useState } from 'react';
import '../css/gallery.css';
import axios from 'axios';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';

const GalleryDetail = () => {
  const [galImages, setGalImages] = useState([]);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isCarousalOpen, setIsCarousalOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(0); // Page starts at index 0
  const imagesPerPage = 9;

  const url = process.env.REACT_APP_BASE_URL

  // Fetch gallery images
  const fetchGalImages = async () => {
    try {
      const response = await axios.get(`${url}/api/gallery/`);
      setGalImages(response.data.data || []);
    } catch (error) {
      if (process.env.NODE_ENV === 'development') {
        console.error('Error fetching gallery images:', error);
      }
    }
  };

  // Open the carousel with a specific image
  const openCarousal = (index) => {
    setCurrentImageIndex(index);
    setIsCarousalOpen(true);
  };

  // Navigate to the previous image
  const goToPreviousImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === 0 ? galImages.length - 1 : prevIndex - 1
    );
  };

  // Navigate to the next image
  const goToNextImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === galImages.length - 1 ? 0 : prevIndex + 1
    );
  };

  // Close the carousel
  const closeCarousal = () => {
    setIsCarousalOpen(false);
  };

  useEffect(() => {
    fetchGalImages();
  }, []);

  // Calculate images for the current page
  const startIndex = currentPage * imagesPerPage;
  const currentImages = galImages.slice(startIndex, startIndex + imagesPerPage);

  // Handle page navigation
  const goToNextPage = () => {
    if (startIndex + imagesPerPage < galImages.length) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
  };

  const goToPreviousPage = () => {
    if (currentPage > 0) {
      setCurrentPage((prevPage) => prevPage - 1);
    }
  };

  return (
    <div className="gallery-container">
  <h2>छायाचित्रदर्शन</h2>
      {/* Carousel */}
      {isCarousalOpen && (
        <div className="gallery-carousal">
          <FaChevronLeft
            className="carousel-icon left-icon"
            onClick={goToPreviousImage}
          />
          <img
            src={`${url}/galimg/${galImages[currentImageIndex]?.image}`}
            alt={galImages[currentImageIndex]?.title}
          />
          <FaChevronRight
            className="carousel-icon right-icon"
            onClick={goToNextImage}
          />
          <span onClick={closeCarousal} className="close-icon">
            X
          </span>
        </div>
      )}

      {/* Gallery Grid */}
      <div className="gallery-images-grid">
        {currentImages.map((image, index) => (
          <img
            key={image._id}
            src={`${url}/galimg/${image.image}`}
            alt={image.title}
            className="gallery-image"
            onClick={() => openCarousal(startIndex + index)}
          />
        ))}
      </div>

      {/* Pagination Controls */}
      <div className="pagination-controls">
        <FaChevronLeft
          className={`pagination-icon ${currentPage === 0 ? 'disabled' : ''}`}
          onClick={goToPreviousPage}
        />
        <span className="pagination-info">
          Page {currentPage + 1} of {Math.ceil(galImages.length / imagesPerPage)}
        </span>
        <FaChevronRight
          className={`pagination-icon ${
            startIndex + imagesPerPage >= galImages.length ? 'disabled' : ''
          }`}
          onClick={goToNextPage}
        />
      </div>
    </div>
  );
};

export default GalleryDetail;
